import React, { memo } from 'react';
import styles from './header.module.scss';

export const Header = memo((props) => {

	return (
		<>
			<div className={styles.header}>
				<h1 className={styles.title}>
					BMクラウド<span className={styles.title_color}>DX</span>診断
					<span className={styles.title_sub}>デジタル化の観点で建物管理業務をチェック！</span>
				</h1>
			</div>
		</>
	);
});
